
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AlertService } from '../../../../services/alert.service';
import { ContractTemplate } from '../../../../models/contract-template.model';


@Component({
    selector: 'create-edit-contract-template-modal',
    template: require('./create-edit-contract-template-modal.component.html'),
    styles: [require('./create-edit-contract-template-modal.component.css')]
})
export class CreateEditContractTemplateModalComponent {
    currentContractTemplate: ContractTemplate;
    isCreatNew: boolean;
    contractTemplateTypes = [];
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditContractTemplateModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentContractTemplate.contractTemplateId == undefined);
        this.currentContractTemplate = data.currentContractTemplate;

    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateContractTemplate(this.currentContractTemplate).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update ContractTemplate successfully");
                }
            });
        } else {
            this.apiService.createContractTemplate(this.currentContractTemplate).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create ContractTemplate successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/contract-templates/create-edit-contract-template-modal/create-edit-contract-template-modal.component.ts